// extracted by mini-css-extract-plugin
module.exports = {"strapiButton":"ResourceEditInStrapiButton_strapiButton__mSZ_B"};